import {Auth} from 'aws-amplify';
import {
  AUTH_USER,
  CLEAR_AUTH_DATA,
  GET_COMPANY_DATA,
  UPDATE_CAR_COUNT,
  SHOW_AUTH_LOAD,
  CLEAR_COMPANY_DATA,
  SHOW_COMPANY_LOAD,
  ADD_COMPANY_DATA,
  HIDE_COMPANY_LOAD,
  UPDATE_FAMILY_MEMBERS,
  UPDATE_COMPANY_WAIVER_SIGNED,
  SIGNUP_RESET,
  UPDATE_COMPANY_MEMBER_TNC,
  UPDATE_LOGOUT_MESSAGE,
  UPDATE_COMPANY_MEMBER_MRF,
  UPDATE_FAMILY_MEMBER_QUESTIONS,
  SET_FAMILY_MEMBER_REGISTRATION_FORM,
} from '../actionTypes';

import {AxiosHelperPortal, showToast} from '../../utility/helperFunctions';
import {BASE_URL_WEB} from '../../utility/constants';
import {resetMembershipPaymentLoginCheck} from '../../utility/membershipPaymentRecovery';

export const loginUser = ({email, password}, flowType = 'USER_SRP_AUTH', login_token = null) => {
  return async dispatch => {
    resetMembershipPaymentLoginCheck();
    dispatch({type: SHOW_AUTH_LOAD, payload: {status: true, err: ''}});
    try {
      Auth.configure({authenticationFlowType: flowType});
      let user = await Auth.signIn(email, password);
      if (login_token !== null && user.challengeName === 'CUSTOM_CHALLENGE') {
        user = await Auth.sendCustomChallengeAnswer(user, login_token);
      }
      if (!user.signInUserSession) {
        throw new Error('Sign-in could not be completed. Please try again.');
      }

      // Every authenticated landing page needs the member profile, including
      // deep links that never mount the dashboard's profile-loading effect.
      const userType =
        user.attributes?.['custom:userType'] ||
        user.signInUserSession.idToken?.payload?.['custom:userType'];
      // Coaches also use custom authentication to open athlete profiles.
      const isCoach = userType === 'company' || userType === 'trainer';
      const profile = isCoach ? null : await companyData();
      if (!isCoach && !profile?.member?.id) {
        throw new Error('Your profile could not be loaded. Please try signing in again.');
      }
      dispatch({
        type: AUTH_USER,
        authDetails: user,
        companyData: profile,
        payload: {status: false, err: ''},
      });
      dispatch({type: SIGNUP_RESET});
    } catch (error) {
      const message =
        error.code === 'NotAuthorizedException'
          ? 'Incorrect username or password!'
          : error.code === 'UserNotFoundException'
          ? 'User does not exist.'
          : error.message || 'Sign-in could not be completed. Please try again.';
      showToast.error(message);
      dispatch({type: SHOW_AUTH_LOAD, payload: {status: false, err: error}});
    }
  };
};

const companyData = async () => {
  const response = await AxiosHelperPortal(BASE_URL_WEB + 'home-user?', 'get');
  return response.data;
};

export const authCompanyData = () => {
  return dispatch => {
    companyData()
      .then(data => {
        dispatch({
          type: GET_COMPANY_DATA,
          payload: data,
        });
      })
      .catch(error => {
        dispatch(hideCompanyDataLoad());
        alert('Error fetching company data. Please refresh the page.');
      });
  };
};
export const updateCarCount = (payload) =>{
 return {
    type: UPDATE_CAR_COUNT,
    payload,
 }
}

export const logoutUser = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_AUTH_DATA,
    });
  };
};

export const publicCompanyData = data => {
  return {
    type: GET_COMPANY_DATA,
    payload: data,
  };
};

export const clearCompanyData = () => {
  return {
    type: CLEAR_COMPANY_DATA,
  };
};

export const showCompanyDataLoad = () => {
  return {
    type: SHOW_COMPANY_LOAD,
  };
};
export const hideCompanyDataLoad = () => {
  return {
    type: HIDE_COMPANY_LOAD,
  };
};

export const addCompanyData = state => {
  return {
    type: ADD_COMPANY_DATA,
    payload: state,
  };
};

export const updateFamilyMembers = payload => {
  return {
    type: UPDATE_FAMILY_MEMBERS,
    payload,
  };
};

export const updateCompanyWaiverSigned = () => {
  return {
    type: UPDATE_COMPANY_WAIVER_SIGNED,
  };
};
export const updateCompanyMemberTnc = () => {
  return {
    type: UPDATE_COMPANY_MEMBER_TNC,
  };
};
export const updateLogoutMessage = message => {
  return {
    type: UPDATE_LOGOUT_MESSAGE,
    payload: message,
  };
};

export const updateCompanyMemberMRF = () => {
  return {
    type: UPDATE_COMPANY_MEMBER_MRF,
  };
};

export const updateFamilyMemberQuestions = (familyMemberId, questionsData) => {
  return {
    type: UPDATE_FAMILY_MEMBER_QUESTIONS,
    payload: {
      familyMemberId,
      questionsData,
    },
  };
};

export const setFamilyMemberRegistrationForm = formData => {
  return {
    type: SET_FAMILY_MEMBER_REGISTRATION_FORM,
    payload: formData,
  };
};
